import _get from 'lodash/get';
export function getPrimaryLocation(locations) {
  if (locations === void 0) {
    locations = [];
  }

  var defaultLocation = locations.find(function (_ref) {
    var primaryLocation = _ref.primaryLocation;
    return primaryLocation;
  });
  return defaultLocation || _get(locations, '[0]', {});
}
export function getPrimaryLocationId(locations) {
  if (locations === void 0) {
    locations = [];
  }

  var primaryLocation = getPrimaryLocation(locations);
  var id = primaryLocation._id;
  return id;
}